class WelcomePopup extends HTMLElement {
  constructor() {
    super();
    this.open = false;
  }

  init(){

    //Check Cookies
    if ( document.cookie.search('welcome_message') !== -1) {
      //not first visit
    } else {
        //first visit
        this.open = true;
        this.classList.add('open');

        //set cookie to avoid showing the modal again
        const expires = new Date();
        expires.setDate(expires.getDate() + 7); // Expira em 7 dias
        document.cookie = `welcome_message=True; expires=${expires.toUTCString()}; path=/;`;

        this.events();

    }
  }

  events(){

    //Close button
    this.querySelector('.button-close').addEventListener('click', () => {
      this.open = false;
      this.classList.remove('open');
      document.dispatchEvent(new Event('modal-close'));
    });

    //Close background
    this.addEventListener('click', (event) => {
        if(event.target === this){
            this.open = false;
            this.classList.remove('open');
            document.dispatchEvent(new Event('modal-close'));
        }
    })
  }

  
}

  customElements.define('welcome-modal', WelcomePopup);
  
  const modalEl = document.getElementsByTagName('welcome-modal');
  console.log('modalEl', modalEl)

  if (modalEl.length > 0) {
      modalEl[0].addEventListener('open', (m) => {
        modalEl[0].init();
      });
  }